import React from "react";
import { Box } from "arkh";

export function WorkspaceRoutineOccasionItemContainer(props: {
  storeName: React.ReactNode;
  createdIssues: React.ReactNode;
  activeIssues: React.ReactNode;
  status: React.ReactNode;
}) {
  return (
    <Box style={{ flexDirection: "row", flex: 1, alignItems: "center" }}>
      <Box style={{ flex: 1, flexDirection: "row", alignItems: "center" }}>
        <Box style={{ width: "50%" }}>{props.storeName}</Box>
        <Box style={{ width: "25%" }}>{props.createdIssues}</Box>
        <Box style={{ width: "25%" }}>{props.activeIssues}</Box>
      </Box>
      <Box style={{ width: 110, alignItems: "flex-end" }}>{props.status}</Box>
    </Box>
  );
}
